import { render } from "./WarningIcon.vue?vue&type=template&id=228a5d26"
const script = {}

import "./WarningIcon.vue?vue&type=style&index=0&id=228a5d26&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__